import React from 'react';

import IProduct from '../../../../models/product';
import InputTextField from '../../../inputfields/InputTextField';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import { isBlank } from 'utils/helpers-ts';
import { useProductValidations } from '../validation-context/ProductValidationContext';

interface IBrandProps {
  approve: boolean;
  state: IProduct;
  setState: (state: IProduct) => void;
  isFood?: boolean;
  onChangedBrand?: () => void;
  readOnly?: boolean;
}

export const correctBrandValue = (value?: string) => {
  if (isBlank(value) || !/(\sAB\s*)$/.test(value!)) return value;
  return value?.replace(/(\sAB\s*)$/, '')?.trim();
};

export const checkBrandError = (state?: IProduct, isFood?: boolean) => {
  const name = isFood ? 'brand_food' : 'brand';

  if (
    (name === 'brand' && !isBlank(state?.brand) && /(\sAB\s*)$/.test(state?.brand!)) ||
    (name === 'brand_food' && !isBlank(state?.brand_food) && /(\sAB\s*)$/.test(state?.brand_food!))
  ) {
    return `Varumärket ska inte innehålla 'AB'. Detta tas bort automatiskt när produkten sparas.`;
  }
  return '';
};

const Brand = ({ approve, state, setState, isFood, onChangedBrand, readOnly }: IBrandProps) => {
  const { requiredFields } = useProductValidations();
  const name = isFood ? 'brand_food' : 'brand';
  // TODO any
  const handleChange = ({ target }: any) => {
    onChangedBrand?.();
    setState({ ...state, [name]: target.value });
  };
  // console.log('!!!state', state);
  return (
    <div style={{ display: 'flex', flex: 1, alignItems: 'end' }}>
      <div style={{ flexGrow: 1 }}>
        <InputTextField<IProduct>
          readOnly={readOnly}
          label="Varumärke"
          dense={false}
          inputName={name}
          value={state[name]}
          onChange={handleChange}
          disabled={state?.isMagazine}
          withLabel
          forceRed={!!checkBrandError(state, isFood)}
          inputClassName="data-hj-allow"
          hideComponentLabel={readOnly}
          labelOptions={{
            required: !!requiredFields[name],
            heading: 'Varumärke',
            text: `Artikelns varumärke. Om artikeln består av flera olika artiklar med olika varumärken, anges valfritt ingående varumärke. Om ej särskilt varumärke finns kan denna kolumn lämnas tom.
            (Samma varumärke som eventuellt angetts i fältet ”Varumärke/Utökad artikelbenämning”)`,
          }}
          helpText={checkBrandError(state, isFood)}
        />
      </div>
      {approve && state?.approve?.find(x => x.field === name) && (
        <ThreeWaySwitch readOnly={readOnly} name={name} state={state} setState={setState} style={{ height: 56, marginBottom: 8 }} />
      )}
    </div>
  );
};

export default Brand;
